<template>
  <EvaluatorLayout
    :title="`Candidato(a)s da vaga de ${job.title}`"
    menu="Vagas"
  >
    <div class="row mb-3">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div
              class="col-lg-6 col-xs-12 text-truncate"
              style="width: 100%"
            >
              <div class="form-group color-dark-purple mb-0">
                <h4 class="label-bold">
                  CANDIDATO(A)S DA VAGA
                  <span style="color: #8f66fe">{{ job.title }}</span>
                </h4>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-3 col-xs-12 p-0">
              <select
                class="form-control"
                v-model="action"
                @change="changeAction"
                :disabled="!selected.length"
              >
                <option
                  disabled
                  value="0"
                >
                  AÇÕES
                </option>
                <option value="2">MUDAR STATUS</option>
              </select>
            </div>

            <div class="col-lg-6">
            </div>
            <div class="col-lg-3 col-xs-12 pl-0 mb-5">
              <div class="form-group mb-0 has-search d-flex justify-content-end">
                <span
                  class="fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
                  style="color: #212529"
                ></span>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchApplies"
                  class="form-control no_border"
                  style="padding: 0px"
                />
                <div class="total_apply color-dark-purple">
                  <span><b>{{ totalApplies }} CANDIDATO(A)S</b></span>
                </div>
              </div>
            </div>
            <div
              v-if="is_admin"
              class="col-lg-2 col-xs-12"
              style="margin-top: 10px"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div class="table-responsive">

          <table class=" table mt-3">
            <thead class="headerTable">
              <tr>
                <td style="width: 5px;"></td>
                <td style="min-width: 200px;">
                  CANDIDATO(A)S
                  <OrderTable
                    field="name"
                    entity="applies"
                  />
                </td>
                <td
                  style="min-width: 200px;"
                  class="center"
                >
                  PROCESSO
                  <OrderTable
                    field="selective_process_id"
                    entity="applies"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 200px;"
                >
                  CARGO
                  <OrderTable
                    entity="applies"
                    field="last_role"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 200px;"
                >
                  EMPRESA
                  <OrderTable
                    entity="applies"
                    field="last_business"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 200px;"
                >
                  CIDADE NATAL
                  <OrderTable
                    entity="applies"
                    field="hometown"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 200px;"
                >
                  ETNIA
                  <OrderTable
                    entity="applies"
                    field="ethnicity"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 300px;"
                >
                  ORIENTAÇÃO SEXUAL
                  <OrderTable
                    entity="applies"
                    field="sexual_orientation"
                  />
                </td>
                <td
                  class="center"
                  style="min-width: 300px;"
                >
                  PCD
                  <OrderTable
                    entity="applies"
                    field="pcd_description"
                  />
                </td>
                <td class="center">
                  DATA
                  <OrderTable
                    entity="applies"
                    field="created_at"
                  />
                </td>
              </tr>
            </thead>
            <tbody class="position-relative">
              <tr
                v-for="(apply, index) in applies"
                :key="apply.id"
                :class="{ 'content-loading': loading }"
              >
                <td
                  class="center"
                  :class="{
                  selected: selected_ids.includes(apply.id),
                  opacity: apply.visibility == false,
                }"
                  style="border-left: 1px solid #fff"
                  :style="{
                  borderLeftColor:
                    apply.tag_color != null ? apply.tag_color : '#fff',
                  borderLeftWidth: '5px',
                }"
                >
                  <CheckBox
                    :id="apply"
                    :index="index"
                    :checked="selected_ids.includes(apply.id)"
                  />
                </td>
                <td :class="{
                  selected: selected_ids.includes(apply.id),
                  opacity: apply.visibility == false,
                }">
                  <div class="d-flex flex-row">
                    <div>
                      <div
                        class="avatar_thumb pointer"
                        @click="show(apply.id, apply.candidate_id, index)"
                      >
                        <img
                          class
                          :src="apply.image || '/images/avatar.png'"
                        />
                      </div>
                      <font-awesome-icon
                        v-if="apply.status >= 1"
                        icon="eye"
                        class="eye f13"
                        style="color: #666464; margin-left: 55px"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        v-if="apply.status == 0"
                        icon="eye-slash"
                        class="eye f13"
                        style="color: #b7b7b7; margin-left: 55px"
                      ></font-awesome-icon>
                    </div>
                    <div class="ml-3 mt-1">
                      {{ apply.name }}<br />
                      <div
                        class="pt-2"
                      >
                        <span
                          class="f14 color-white font-weight-bold p-2"
                          :style="`background-color: ${ apply.tag_color || 'null' }; text-shadow: 0px 0px 3px black`"
                          v-if="apply.tag_name != null"
                        >
                          {{ apply.tag_name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td :class="{selected: selected_ids.includes(apply.id)}" class="pt-3">
                <div :class="`status${apply.status}`">{{status[apply.status]}}</div>
              </td>-->
                <td
                  :class="{
                  selected: selected_ids.includes(apply.id),
                  opacity: apply.visibility == false,
                }"
                  class="pt-3 center"
                >
                  <div
                    class="block_process"
                    style="border-radius: 0px"
                    :class="`process${apply.selective_process_status}`"
                  >
                    {{ apply.selective_process_name }}
                  </div>
                  <div
                    v-for="(evaluation, index) in evaluations.filter((e) => e.selective_process_id == apply.selective_process_id)"
                    :key="`evaluation_${apply.selective_process_id}_${index}`"
                    class="row"
                  >
                    <span
                      class="f14 mt-1"
                      style="text-align: center; width: 100%;"
                    >
                      {{ getEvaluationName(evaluation) }}
                      <font-awesome-icon
                        class="color-primary"
                        :icon="getEvaluationStatus(evaluation, apply)"
                      />
                    </span>
                  </div>
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.last_role }}
                </td>
                
                <td class="pt-3 center color-dark-purple">
                  {{ apply.last_business }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.hometown_attributes ? 
                    `${apply.hometown_attributes.name}/${apply.hometown_state_attributes.name}`:
                    `Não definido`
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ getEthnicity(apply.ethnicity) || "Não definido" }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ getSexualOrientation(apply.sexual_orientation) || "Não definido" }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.is_pcd ? apply.pcd_description : "Não" }}
                </td>
               
                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                  selected: selected_ids.includes(apply.id),
                  opacity: apply.visibility == false,
                }"
                >
                  {{ formattedDate(apply.created_at) }}
                </td>
              </tr>
              <div
                class="center position-absolute loading-gif"
                :class="{ 'd-none': !loading || firstLoad }"
              >
                <img
                  src="/images/loading.gif"
                  alt="loading-gif"
                />
              </div>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
      </div>
    </div>
  </EvaluatorLayout>
</template>

<script>
import moment from "moment";
import EvaluatorLayout from "layouts/Evaluator.vue";
import ApplyShow from "./ApplyShow.vue";
import OrderTable from "components/OrderTable.vue";
import CheckBox from "components/CheckBox.vue";
import ChangeSelectiveProcess from "@/Recruiters/Applies/ChangeSelectiveProcess.vue";
import vPagination from "vue-plain-pagination";
import { state } from "store/business.js";

export default {
  components: {
    EvaluatorLayout,
    ApplyShow,
    OrderTable,
    CheckBox,
    vPagination
  },
  props: [
    "job",
    "selective_processes",
    "info_tags",
    "recruiter_id",
    "is_admin",
    "is_evaluator",
    "schema_params",
    "evaluations"
  ],
  data: () => ({
    status: ["Não avaliado", "Visualizado", "Avaliado"],
    search: "",
    kanban: false,
    applies: [],
    field: "",
    order: "",
    selected: [],
    selected_ids: [],
    firstLoad: true,
    loading: false,
    totalApplies: 0,
    currentPage: 1,
    pageCount: 1,
    state: state,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
    ethnicities: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    sexual_orientations: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" },
    ],
    action: "",
  }),
  watch: {
    currentPage: function () {
      this.searchApplies();
    },
    "state.extra_options"() {
      this.setExtraOptions();
    }
  },
  methods: {
    changeAction() {
      if (this.action == 2) {
        this.showChangeStatus();
      }
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    searchApplies() {
      if (this.search != "") {
        this.selected = [];
        this.selected_ids = [];
        eventBus.$emit("no_check", true);
      }
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      params["where"] = { selective_process_id: this.schema_params.selective_process_id} 

      this.loading = true;
      axios
        .get(
          `/recruiters/jobs/${this.job.id}/applies/search/${this.currentPage}`,
          {
            params: params,
          }
        )
        .then((response) => {
          this.applies = response.data.applies.apply_search;
          this.totalApplies = response.data.applies.total_applies;
          this.pageCount = Math.ceil(this.totalApplies / 15);
          this.firstLoad = false;
          this.loading = false;
        });
    },
    showChangeStatus() {
      this.$modal.show(
        ChangeSelectiveProcess,
        {
          job_id: this.job.id,
          applies: this.applies,
          apply_ids: this.selected,
          selective_processes: this.selective_processes,
          selected: this.selected,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    show(apply_id, candidate_id, index) {
      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: this.applies,
          job_id: this.job.id,
          job_name: this.job.title,
          apply_id: apply_id,
          candidate_id: candidate_id,
          user_manager: false,
          talent_bank_id: this.applies[index].talent_bank_id,
          recruiter_id: this.recruiter_id,
          hitsPercentage: this.applies[index].hitsPercentage,
          selective_process_id: this.schema_params.selective_process_id,
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    getEthnicity(ethnicity_id) {
      const ethnicity = this.ethnicities.find(
        (ethnicity) => ethnicity.id === ethnicity_id
      );
      if (ethnicity) {
        return ethnicity.name;
      }
      return "Não definido";
    },
    getSexualOrientation(sexual_orientation_id) {
      const sexual_orientation = this.sexual_orientations.find(
        (sexual_orientation) => sexual_orientation.id === sexual_orientation_id
      );
      if (sexual_orientation) {
        return sexual_orientation.name;
      }
      return "Não definido";
    },
    setExtraOptions() {
      if (this.state.extra_options) {
        this.state.extra_options?.ethnicity?.length > 0 ?  
          this.ethnicities = this.state.extra_options?.ethnicity?.map((ethnicity, index) => {
            return { name: ethnicity, id: index }
          }) 
        : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0 ?  
          this.sexual_orientations = this.state.extra_options?.sexual_orientation?.map((sexual_orientation, index) => {
            return { name: sexual_orientation, id: index }
          })
        : this.sexual_orientations;
      }
    },
    getEvaluationName(evaluation) {
      if (evaluation) {
        return evaluation?.name || "Prova sem nome";
      }
      return "Não definido";
    },
    getEvaluationStatus(evaluation, apply) {
      let status = "envelope";
      if (
        apply.answers.find(
          (answer) => answer.evaluation_id == evaluation.id
        )
      ){
        status = "user-clock";
      }
      apply.evaluations_done_schema.forEach((evaluation_done) => {
        if (evaluation_done.evaluation_id == evaluation.id) {
          status = "check";
        }
      });
      return status;
    }
  },
  mounted() {
    this.action = 0;
    eventBus.$on("orderColumnapplies", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchApplies();
    });

    eventBus.$on("resetSelected", () => {
      this.selected = [];
      this.selected_ids = [];
      eventBus.$emit("no_check", true);
    });

    eventBus.$on("checkbox", (fields) => {
      let index_id = -1;
      for (let i in this.selected) {
        if (this.selected[i].id == fields.id.id) {
          index_id = i;
          break;
        }
      }
      if (index_id != -1) this.selected.splice(index_id, 1);

      const index_i = this.selected_ids.indexOf(fields.id.id);
      if (index_i > -1) this.selected_ids.splice(index_i, 1);

      if (fields.operator) {
        this.selected.push(fields.id);
        this.selected_ids.push(fields.id.id);
      }
    });
    eventBus.$on("closeApplyUploadDialog", () => {
      this.$modal.hideAll();
      this.$toast.success("ARQUIVO ENVIADO COM SUCESSO!");
      this.searchApplies();
    });
    this.searchApplies();
    this.setExtraOptions();
  },
};
</script>

<style>
</style>